import Button from '@/components/Button'
import Layout, { Stack } from '@/components/Layout'
import Text from '@/components/Text'
import { useTranslation } from 'next-i18next'

export interface Props {
  onClickProceed?: () => void
  onClickCancel?: () => void
}

const CancelBookingConfirm = ({ onClickProceed, onClickCancel }: Props): JSX.Element => {
  const { t } = useTranslation('classes')
  return (
    <Layout spacing="sm">
      <Stack y className="ta-c">
        <Text>{t('cancelClass.title')}</Text>
        <Text weight="sm">{t('cancelClass.message1')}</Text>
        <Text weight="sm">{t('cancelClass.message2', { proceedLabel: t('cancelClass.proceedLabel') })}</Text>
        <Stack x justifyContent="space-around">
          <Button label={t('cancelClass.cancelLabel')} theme="primary" onClick={onClickCancel} />
          <Button label={t('cancelClass.proceedLabel')} onClick={onClickProceed} />
        </Stack>
      </Stack>
    </Layout>
  )
}
export default CancelBookingConfirm
